import type { ReactElement } from 'react';

import { AspectRatio } from '@rango-dev/whale';
import React from 'react';

import { Image } from '../../common/Image';

import styles from './CampaignsCarousel.module.css';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const CAMPAIGN_RATIO = 376 / 211.5;

export function CampaignCarousel(): ReactElement {
  return (
    <a
      href="https://zealy.io/cw/rangoexchange/questboard"
      target="_blank"
      rel="noreferrer"
      className={styles.link}>
      <AspectRatio ratio={CAMPAIGN_RATIO}>
        <Image src="/imgs/profile/zealy.jpg" alt="Zealy Campaign" className={styles.image} />
      </AspectRatio>
    </a>
  );
}
